import UserProfileComponent from './UserProfileComponent';

export default class ListBox extends UserProfileComponent {
    templateId() {
        return '#listBoxTemplate';
    }

    load(containerId) {
        Handlebars.registerPartial('items', $('#itemsTemplate').html());
        super.load(containerId);
    }
}
